exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-default-button[data-v-48abab45] {\n  float: right;\n}\n.backdrop[data-v-48abab45] {\n  background: rgba(0, 0, 0, 0.6);\n}\n", ""]);

// exports
